import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupByPlayer } from './gameSlice';
import Cookies from "js-cookie";
import api from '../../api';
import { getUserColor } from '../../utils/index';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { gsap, Elastic } from "gsap/all";
import useDisableBrowserBack from "../hooks/useDisableBrowserBack";
import useReadCookies from "../hooks/useReadCookies";
import PlayerLabel from './shared/playerLabel';

function Roles()
{
  useDisableBrowserBack();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const players = useSelector((state) => state.game.players);
  const playerCount = useSelector((state) => state.game.playerCount);
  const roleAssignedPlayerCount = useSelector((state) => state.game.roleAssignedPlayerCount);

  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [duplicateRole, setDuplicateRole] = useState('');
  const [duplicatePlayer, setDuplicatePlayer] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRoleAssigning, setIsRoleAssigning] = useState(false);

  const [readingRole, setReadingRole] = useState('');
  const [earthRole, setEarthRole] = useState('');
  const [natureRole, setNatureRole] = useState('');
  const [artRole, setArtRole] = useState('');

  const [readingBorderColor, setReadingBorderColor] = useState('');
  const [earthBorderColor, setEarthBorderColor] = useState('');
  const [natureBorderColor, setNatureBorderColor] = useState('');
  const [artBorderColor, setArtBorderColor] = useState('');

  let {cookiePlayerId} = useReadCookies();

  const [hideHelpMessage, setHideHelpMessage] = useState(false);
  //let duplicateMessageRef = useRef(null);


  useEffect(()=>{
    dispatch(getGroupByPlayer(cookiePlayerId));
    // polling for group status every 5 seconds until group is confirmed  
    const interval = setInterval(() => {
      dispatch(getGroupByPlayer(cookiePlayerId));
    } , 5000);  
    return () => clearInterval(interval);
  }, []);

  useEffect(()=>{
    
  }, [])

  useEffect(()=>{
    setReadingRole('');
    setEarthRole('');
    setNatureRole('');
    setArtRole('');
    setReadingBorderColor('');
    setEarthBorderColor('');
    setNatureBorderColor('');
    setArtBorderColor('');
    players.forEach(player => {
      if(player.role === 'reading'){
        setReadingRole(player);
        setReadingBorderColor(getUserColor(player.secret));
      }
      else if(player.role === 'earth'){
        setEarthRole(player);
        setEarthBorderColor(getUserColor(player.secret));
      }
      else if (player.role === 'nature'){
        setNatureRole(player);
        setNatureBorderColor(getUserColor(player.secret));
      }
      else if(player.role === 'art') {
        setArtRole(player);
        setArtBorderColor(getUserColor(player.secret));
      }
    });
  }, [players]);

  const assignRoleHandler = (role) => {
    setIsRoleAssigning(true);
    api.selectRole(cookiePlayerId, role).then(result => {
      if(result.status === 200){
        if(!result.data.success){
          setDuplicateRole(result.data.role);
          setDuplicatePlayer(result.data.currently_assigned);
          setShowDuplicatePopup(true);
          //popupAnimation.clear();
          //popupAnimation.fromTo(duplicateMessageRef, { y: -600}, { y: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)}).play();
        }
        dispatch(getGroupByPlayer(cookiePlayerId));
        setIsRoleAssigning(false);
      }
    });
  };

  /*
  const popupCloseHanlder = () => {
    popupAnimation.reverse();
    const timelineDuration = popupAnimation.duration() * 1000;
    setTimeout(()=>{
      setShowDuplicatePopup(false);
    }, timelineDuration);
  };*/

  const continueButtonHandler = e => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(()=>{
      navigate('/app/game/outro/1' + window.location.search);
    }, 500);
  };

  const interactionStartedHandler = e => {
    console.log('bla')
    setHideHelpMessage(true);
  }
/*
  const getRoleFillColor = (role) => {
    let fillColor = '#ffffff';
    switch(role) {
      case 'reading':
        if(readingRole.secret === cookiePlayerId){
          fillColor = '#292929';
        }else if(readingRole !== ''){
          fillColor = '#DCCDB3';
        }
        break; 
      case 'earth':
        if(earthRole.secret === cookiePlayerId){
          fillColor = '#292929';
        }else if(earthRole !== ''){
          fillColor = '#DCCDB3';
        }
        break; 
      case 'nature':
        if(natureRole.secret === cookiePlayerId){
          fillColor = '#292929';
        }else if(natureRole !==''){
          fillColor = '#DCCDB3';
        }
        break;
      case 'art':
        if(artRole.secret === cookiePlayerId){
          fillColor = '#292929';
        }else if(artRole !==''){
          fillColor = '#DCCDB3';
        }
        break;
      default:
        fillColor = '#ffffff';
    }
    return fillColor;
  };*/

  return (
    <div className="mobileContainer super-power-screen backgroundQuestionPattern" onClick={interactionStartedHandler}>
      <div className='super-power-wrapper'>
        <div className='title-wrapper'>
          <h3>{t("student.roles.title")}</h3>
        </div>
        <ul className='answers'>
          <li onClick={() => assignRoleHandler('reading')} className={`answer ${readingRole !== '' ? 'selected' : ''} ${readingRole !== '' && readingRole.secret === cookiePlayerId ? 'current' : 'other'}`} style={{ backgroundColor: readingBorderColor }}>
            <div className='ornament'></div>
            <div className='caption'>{t("student.roles.language_and_reading")}</div>
            <div className='check-indicator'></div>
            {readingRole !== '' && readingRole.secret != cookiePlayerId && <PlayerLabel playerName={readingRole.name} playerColor={readingBorderColor} />}
          </li>
          <li onClick={() => assignRoleHandler('earth')} className={`answer ${earthRole !== '' ? 'selected' : ''} ${earthRole !== '' && earthRole.secret === cookiePlayerId ? 'current' : 'other'}`} style={{ backgroundColor: earthBorderColor }}>
            <div className='ornament'></div>
            <div className='caption'>{t("student.roles.earth_and_cultures")}</div>
            <div className='check-indicator'></div>
            {earthRole !== '' && earthRole.secret != cookiePlayerId && <PlayerLabel playerName={earthRole.name} playerColor={earthBorderColor}/>}
          </li>
          <li onClick={() => assignRoleHandler('nature')} className={`answer ${natureRole !== '' ? 'selected' : ''} ${natureRole !== '' && natureRole.secret === cookiePlayerId ? 'current' : 'other'}`} style={{ backgroundColor: natureBorderColor }}>
            <div className='ornament'></div>
            <div className='caption'>{t("student.roles.nature_and_chemistry")}</div>
            <div className='check-indicator'></div>
            {natureRole !== '' && natureRole.secret != cookiePlayerId && <PlayerLabel playerName={natureRole.name} playerColor={natureBorderColor}/>}
          </li>
          <li onClick={() => assignRoleHandler('art')} className={`answer ${artRole !== '' ? 'selected' : ''} ${artRole !== '' && artRole.secret === cookiePlayerId ? 'current' : 'other'}`} style={{ backgroundColor: artBorderColor }}>
            <div className='ornament'></div>
            <div className='caption'>{t("student.roles.art_and_culture")}</div>
            <div className='check-indicator'></div>
            {artRole !== '' && artRole.secret != cookiePlayerId && <PlayerLabel playerName={artRole.name} playerColor={artBorderColor}/>}
          </li>
        </ul>
        <div className={`help ${hideHelpMessage ? 'hide' : ''}`}>
          <div className='speechBalloonSmall'>
            <p>
              {t("student.roles.help")}
            </p>
          </div>
        </div>
        <div className={`navigationDrawer spread variant6 enableInAnimation`}>
          <a className="chromelessIconButton visibility-hidden">
            <span className="icon icon-backward-simple"></span>
          </a>
          <button type="submit" className={`chromelessIconButton ${roleAssignedPlayerCount != playerCount || isSubmitting ? 'disabled' : ''}`} disabled={roleAssignedPlayerCount != playerCount || isSubmitting} onClick={continueButtonHandler}>
            <span className="caption">{t("student.roles.continue_button")}</span>
            <span className={`icon ${isSubmitting ? 'icon-forward-simple' : 'icon-forward'}`}></span>
          </button>
        </div>
      </div>
    </div>
  );
  /*
  return(
    <div className="mobile-container super-power-screen">
      <div className="content-wrapper">
        <h3 ref={e => {titleRef = e}}>{t("student.roles.title")}</h3>
        <div className="group-card" ref={e => {groupRef = e}}>
          <ul>
            <li onClick={()=> assignRoleHandler('reading')} className={`${readingRole !== '' ? 'selected' : ''} ${readingRole !== '' && readingRole.secret === cookiePlayerId ? 'current' : ''}`} style={ { borderColor: readingBorderColor}}>
              <div className="icon">
                <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill={getRoleFillColor('reading')} d="M21 16.875V1.125C21 0.515625 20.4844 0 19.875 0H4.5C1.96875 0 0 2.01562 0 4.5V19.5C0 22.0312 1.96875 24 4.5 24H19.875C20.4844 24 21 23.5312 21 22.875V22.125C21 21.6562 20.6719 21.2344 20.25 21.0938V17.9531C20.6719 17.8125 21 17.3906 21 16.875ZM6 6.75C6 6.375 6.32812 6 6.75 6H15.75C16.125 6 16.5 6.375 16.5 6.75C16.5 7.17188 16.125 7.5 15.75 7.5H6.70312C6.32812 7.5 6 7.17188 6 6.79688V6.75ZM6 9.75C6 9.375 6.32812 9 6.75 9H15.75C16.125 9 16.5 9.375 16.5 9.75C16.5 10.1719 16.125 10.5 15.75 10.5H6.70312C6.32812 10.5 6 10.1719 6 9.79688V9.75ZM3 19.5C3 18.7031 3.65625 18 4.5 18H18V21H4.5C3.65625 21 3 20.3438 3 19.5Z" />
                </svg>
              </div>
              <div className="role-name">
                <p>{t("student.roles.language_and_reading")}</p>
              </div>
              {readingRole !== '' && <div className="player-name" style={{backgroundColor: readingBorderColor}}>{readingRole.secret === cookiePlayerId ? 'Jij' :readingRole.name}</div>}
            </li>
            <li onClick={()=> assignRoleHandler('earth')} className={`${earthRole !== '' ? 'selected' : ''} ${earthRole !== '' && earthRole.secret === cookiePlayerId ? 'current' : ''}`} style={ { borderColor: earthBorderColor}}>
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill={getRoleFillColor('earth')} d="M8.71875 1.26562C5.57812 2.20312 3 4.54688 1.6875 7.5H6.375C6.79688 4.92188 7.64062 2.71875 8.71875 1.26562ZM7.5 12C7.5 13.0781 7.54688 14.0625 7.64062 15H16.3125C16.4062 14.0625 16.5 13.0781 16.5 12C16.5 10.9688 16.4062 9.98438 16.3125 9H7.64062C7.54688 9.98438 7.5 10.9688 7.5 12ZM16.0781 7.5C15.3281 3.375 13.5938 0.75 12 0.75C10.3594 0.75 8.625 3.375 7.875 7.5H16.0781ZM22.2656 7.5C20.9531 4.54688 18.375 2.20312 15.2344 1.26562C16.3125 2.71875 17.1562 4.92188 17.5781 7.5H22.2656ZM15.2344 22.7812C18.375 21.8438 20.9531 19.5 22.2656 16.5H17.5781C17.1562 19.125 16.3125 21.3281 15.2344 22.7812ZM22.8281 9H17.8125C17.9062 9.98438 18 10.9688 18 12C18 13.0781 17.9062 14.0625 17.8125 15H22.8281C23.0625 14.0625 23.25 13.0781 23.25 12C23.25 10.9688 23.0625 9.98438 22.8281 9ZM7.875 16.5C8.625 20.6719 10.3594 23.25 12 23.25C13.5938 23.25 15.3281 20.6719 16.0781 16.5H7.875ZM6 12C6 10.9688 6.04688 9.98438 6.14062 9H1.125C0.890625 9.98438 0.75 10.9688 0.75 12C0.75 13.0781 0.890625 14.0625 1.125 15H6.14062C6.04688 14.0625 6 13.0781 6 12ZM1.6875 16.5C3 19.5 5.57812 21.8438 8.71875 22.7812C7.64062 21.3281 6.79688 19.125 6.375 16.5H1.6875Z"/>
                </svg>
              </div>
              <div className="role-name">
                <p>{t("student.roles.earth_and_cultures")}</p>
              </div>
              {earthRole !== '' && <div className="player-name" style={{backgroundColor: earthBorderColor}}>{earthRole.secret === cookiePlayerId ? 'Jij' : earthRole.name}</div>}
            </li>
            <li onClick={()=> assignRoleHandler('nature')} className={`${natureRole !== '' ? 'selected' : ''} ${natureRole !== '' && natureRole.secret === cookiePlayerId ? 'current' : ''}`} style={ { borderColor: natureBorderColor}}>
              <div className="icon">
                <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill={getRoleFillColor('nature')} d="M25 6.78125C25 4.71875 24.5312 2.60938 23.7812 0.875C23.5469 0.40625 22.8906 0.40625 22.6094 0.875C21.1562 3.35938 18.25 4.34375 15.625 3.73438C14.4062 3.45312 13.1406 3.40625 11.8281 3.73438C8.73438 4.4375 6.29688 6.92188 5.64062 10.0156C5.54688 10.5312 5.5 11.0469 5.5 11.5625C8.07812 9.64062 11.6875 8 16.75 8C17.125 8 17.5 8.375 17.5 8.75C17.5 9.17188 17.125 9.5 16.75 9.5C5.26562 9.5 1.46875 18.2656 1 20.1406C0.859375 20.75 1.23438 21.3594 1.84375 21.5C1.9375 21.5 2.03125 21.5 2.125 21.5C2.59375 21.5 3.0625 21.1719 3.20312 20.6562C3.20312 20.6094 3.90625 17.9375 6.4375 15.5938C7.84375 18.3125 10.7031 20 13.75 20C14.7812 20 15.8125 19.8125 16.75 19.4375C21.6719 17.7969 25 12.7812 25 6.78125Z"/>
                </svg>
              </div>
              <div className="role-name">
                <p>{t("student.roles.nature_and_chemistry")}</p>
              </div>
              {natureRole !== '' && <div className="player-name" style={{backgroundColor: natureBorderColor}}>{natureRole.secret === cookiePlayerId ? 'Jij' : natureRole.name}</div>}
            </li>
            <li onClick={()=> assignRoleHandler('art')} className={`${artRole !== '' ? 'selected' : ''} ${artRole !== '' && artRole.secret === cookiePlayerId ? 'current' : ''}`} style={ { borderColor: artBorderColor}}>
              <div className="icon">
                <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill={getRoleFillColor('art')} d="M10.6562 11.5312C9.01562 12 7.84375 13.4531 7.98438 15C8.5 14.3906 9.34375 13.875 10.3281 13.5469L10.6562 11.5312ZM5.45312 13.875L4 5.4375C3.95312 5.34375 4 5.29688 4 5.29688C6.71875 3.79688 9.76562 3 12.8594 3C12.9531 3 13 3.04688 13.0938 3.04688C13.75 2.39062 14.5469 1.96875 15.4844 1.78125C16.375 1.64062 17.2656 1.59375 18.1562 1.54688C17.6875 0.890625 17.0312 0.421875 16.2344 0.28125C15.1094 0.09375 13.9844 0 12.8594 0C9.25 0 5.73438 0.9375 2.54688 2.71875C1.42188 3.32812 0.8125 4.64062 1.04688 5.95312L2.5 14.3906C3.20312 18.1406 8.92188 21.0469 12.1094 21.0469C12.25 21.0469 12.4375 21 12.5781 21C11.9219 20.2031 11.2188 19.0781 10.7031 17.8125C8.5 17.2031 5.73438 15.4219 5.45312 13.875ZM10.0469 7.40625C10 7.21875 9.95312 7.03125 9.85938 6.89062C9.48438 7.3125 8.875 7.59375 8.21875 7.73438C7.51562 7.875 6.85938 7.73438 6.34375 7.5C6.34375 7.6875 6.29688 7.875 6.34375 8.0625C6.53125 9.09375 7.51562 9.75 8.5 9.5625C9.53125 9.42188 10.2344 8.4375 10.0469 7.40625ZM29.4062 5.67188C25.2344 3.375 20.4531 2.53125 15.7188 3.28125C14.4531 3.46875 13.4219 4.5 13.1875 5.8125L11.7344 14.25C10.9844 18.3281 16.1875 23.4375 19.1406 23.9531C22.0938 24.4688 28.7031 21.4688 29.4531 17.3438L30.9062 8.95312C31.1406 7.64062 30.5312 6.32812 29.4062 5.67188ZM16.6094 10.2188C16.7969 9.23438 17.7812 8.53125 18.7656 8.71875C19.7969 8.90625 20.5 9.84375 20.3125 10.875C20.2656 11.0625 20.2188 11.25 20.125 11.4375C19.7031 11.0156 19.1406 10.6875 18.4375 10.5469C17.7812 10.4531 17.125 10.5469 16.6094 10.7812C16.5625 10.5938 16.5625 10.4062 16.6094 10.2188ZM19.8906 19.5469C17.3125 19.0781 15.5312 16.7812 15.7656 14.25C16.7031 15.4688 18.3906 16.4062 20.4062 16.7812C22.4219 17.1562 24.3438 16.7812 25.6562 15.9844C25 18.4219 22.5156 20.0156 19.8906 19.5469ZM26.0312 12.4688C25.6562 12.0469 25.0469 11.7188 24.3438 11.5781C23.6875 11.4844 23.0312 11.5781 22.5156 11.8594C22.4688 11.6719 22.4688 11.4844 22.5156 11.25C22.7031 10.2656 23.6875 9.5625 24.6719 9.75C25.7031 9.9375 26.4062 10.9219 26.2188 11.9062C26.1719 12.0938 26.125 12.2812 26.0312 12.4688Z"/>
                </svg>
              </div>
              <div className="role-name">
                <p>{t("student.roles.art_and_culture")}</p>
              </div>
              {artRole !== '' && <div className="player-name" style={{backgroundColor: artBorderColor}}>{artRole.secret === cookiePlayerId ? 'Jij' : artRole.name}</div>}
            </li>
          </ul>
          <div className={`loading ${isRoleAssigning ? 'show' : ''}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.75 0.75C20.9062 0.75 20.25 1.45312 20.25 2.25V4.40625C18.1406 2.10938 15.1406 0.75 12 0.75C7.125 0.75 2.85938 3.84375 1.3125 8.4375C0.984375 9.42188 1.5 10.4531 2.48438 10.7812C2.67188 10.875 2.90625 10.875 3.09375 10.875C3.89062 10.875 4.59375 10.4062 4.875 9.60938C5.90625 6.5625 8.76562 4.5 12 4.5C14.3438 4.5 16.5469 5.67188 17.9531 7.5H17.1094V7.54688H15.7031C14.9062 7.54688 14.25 8.20312 14.25 9C14.25 9.84375 14.9062 10.5 15.7031 10.5H21.75C22.125 10.5 22.5 10.3594 22.7812 10.0781C23.0625 9.79688 23.25 9.42188 23.25 9.04688V2.25C23.25 1.45312 22.5469 0.75 21.75 0.75ZM21.4688 13.2656C20.4844 12.8906 19.4062 13.4531 19.0781 14.4375C18.0469 17.4844 15.1875 19.5 12 19.5C9.60938 19.5 7.40625 18.375 6 16.5H6.84375H8.25C9.04688 16.5 9.75 15.8438 9.75 15C9.75 14.2031 9.04688 13.5 8.25 13.5H2.20312C1.82812 13.5 1.45312 13.6875 1.17188 13.9688C0.890625 14.25 0.75 14.625 0.75 15V21.7969C0.75 22.5938 1.40625 23.25 2.20312 23.25C3.04688 23.25 3.70312 22.5938 3.70312 21.7969V19.6406C5.8125 21.9375 8.8125 23.25 12 23.25C16.8281 23.25 21.0938 20.2031 22.6406 15.6094C22.9688 14.625 22.4531 13.5938 21.4688 13.2656Z" fill="#fff"/>
            </svg>
          </div>
        </div>
        <div className="lion" ref={e => {lionRef = e}}>
          <img src="/images/lion.png" width={218} height={216} />
        </div>
        <div className="help" ref={e => {helpRef = e}}>
          <p>{t("student.roles.help")}</p>
        </div>
    </div>
    <div className="control-panel" ref={e => {controlbarRef = e}}>
      <a className="back visibility-hidden" href="">
        <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1.5L3 10.5L12 19.5" stroke="white" strokeWidth="4"/>
        </svg>
      </a>
      <button type="submit" className={`continue-button ${roleAssignedPlayerCount != playerCount || isSubmitting ? 'invalid' : ''}`}  disabled={roleAssignedPlayerCount != playerCount || isSubmitting } onClick={continueButtonHandler}>
        <div className="label">{t("student.roles.continue_button")}</div>
        <div className="arrow">
            <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 1.5L11 10.5L2 19.5" stroke={`${ roleAssignedPlayerCount != playerCount || isSubmitting ? '#183060': 'white'}`} strokeWidth="4"/>
            </svg>
        </div>
      </button>
    </div>
    <div className={`popup-wrapper ${showDuplicatePopup ? 'show' : ''}`}>
        <div className="popup-message" ref={ e => duplicateMessageRef = e}>
            <p>{t("student.roles.role_taken_message_1", {player: duplicatePlayer.name})} 
            {duplicateRole === 'reading' && <span> {t("student.roles.language_and_reading")} </span>} 
            {duplicateRole === 'earth' && <span> {t("student.roles.earth_and_cultures")} </span>} 
            {duplicateRole === 'nature' && <span> {t("student.roles.nature_and_chemistry")} </span>} 
            {duplicateRole === 'art' && <span> {t("student.roles.art_and_culture")} </span>} 
            {t("student.roles.role_taken_message_2")}</p>
            <button onClick={popupCloseHanlder}>OK</button>
        </div>
    </div>
  </div>
  )*/
};

export default Roles;